import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen bg-[#111] text-white flex flex-col items-center justify-center p-4">
          <div className="bg-red-500/10 border border-red-500 rounded-lg p-6 max-w-lg w-full">
            <h1 className="text-xl font-bold text-red-500 mb-4">Something went wrong.</h1>
            <p className="mb-4 text-gray-300">
              An error occurred while rendering this page. Please try refreshing.
            </p>
            {this.state.error && (
              <div className="bg-black/50 p-4 rounded overflow-auto text-sm font-mono text-red-400 mb-4 max-h-64">
                {this.state.error.toString()}
              </div>
            )}
            <button
              onClick={() => window.location.reload()}
              className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded transition-colors"
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
